import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useAuthStore from '../store/useAuthStore';

const ProtectedRoute = () => {
    // بنسحب حالة الدخول العادية وحالة الزائر من الـ Store
    const { isAuthenticated, token, isGuest } = useAuthStore();

    // العميل يقدر يدخل لو هو مسجل دخول (معاه توكن) أو لو هو داخل كزائر (Guest)
    const canAccess = isAuthenticated || token || isGuest;

    // لو مسموحله يفتح الصفحة (Outlet)، لو لأ رجعه للوجين
    return canAccess ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;